exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar--left{display:flex;align-items:center}.avatar--left .avatar__img{margin-right:8px}.avatar--left .avatar__text{margin-top:0}.avatar__img{width:80px;height:80px;border-radius:50%;object-fit:cover}.avatar__img--default{background-color:#e2e7ee}.avatar__img--mini{width:24px;height:24px}.avatar__text{font-family:\"Inter-regular\";font-weight:normal;font-size:14px;line-height:1.5;margin-top:8px;text-align:center}\n", ""]);

// exports
